import { IPlan, IPriceStructure } from ".";

export const business: IPlan = {
  id: "business",
  name: "Business",
  description: "Support large-scale publishing with premium integrations and unlimited members.",
  chargebee: new Set([
    "business-monthly-aud",
    "business-monthly-usd",
    "business-monthly-eur",
    "business-monthly-gbp",
    "business-annual-aud",
    "business-annual-usd",
    "business-annual-eur",
    "business-annual-gbp",
  ]),
  features: {
    "organisation-manage-publish-configurations": true,
    "organisation-team-leader-view": true,
    "organisation-team-limit": 3,
    "organisation-member-limit": 200,
    "organisation-team-member-limit": 200,
    "organisation-sites": true,
    "page-settings-amp-enabled": false,
    "page-settings-analytics-ga": true,
    "page-settings-override-social-cover-url": true,
    "shorthand-analytics-tracking": true,
    "story-credits-required": true,
    "themes-demo": false,
    "publish-embed-ui": true,
    "story-comments": true,
    "theme-builder": true,
    "page-settings-password-protect-previews": true,
    "custom-hosting-limit": 5,
    "publish-configurations-download": true,
    "page-settings-analytics-gtm": true,
    "developer-tools": true,
    "page-settings-custom-head": true,
    "shorthand-secure-hosting-enabled": true,
    "foreground-animation": true,
    charts: true,
    "story-text-translation": true,
  },
  marketing: {
    label: "Advanced integrations with upgraded support.",
    className: "plan-business",
    benefits: [
      "Volume publishing discounts",
      "Self-hosted publishing options",
      "Secure publishing destinations",
      "Advanced integrations & 3rd party analytics",
      "Workspace analytics exports",
      "Custom HTML & developer tools",
      "Bespoke custom branded theme",
      "Team onboarding",
      "Story reviews",
    ],
    storyInclusions: 24,
    seatInclusions: "Unlimited",
    prices: {
      planPrice: {
        monthly: { USD: 1750 },
        yearly: { USD: 1400 },
        nfp: { USD: 1050 },
      },
      publishAddonPrice: {
        monthly: { USD: 300 },
        yearly: { USD: 300 },
        nfp: { USD: 180 },
      },
    } as IPriceStructure,
  },
};
